import React, { useRef, useState } from 'react'
import { Dropdown, Menu, Popconfirm, Switch } from 'antd'
import { MenuItemType } from 'antd/es/menu/hooks/useItems'
import { MoreOutlined } from '@ant-design/icons'
import styled, { css } from 'styled-components'

export type ActionDropdownItemsType = {
  label: string
  type: 'normal' | 'confirm' | 'toggle'
  onClick: () => void
  popConfirmTitle?: string
  popConfirmDescription?: string
  disabled?: boolean
  icon?: JSX.Element
  switchState?: boolean
}

type ActionDropdownProps = {
  actionDropdownItems: ActionDropdownItemsType[]
  label: string
}
interface ToggleDivProps {
  disabled?: boolean
}

const ToggleDiv = styled.div<ToggleDivProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.6;
      pointer-events: none;
    `}
`

const ActionDropdown = ({
  actionDropdownItems,
  label,
}: ActionDropdownProps) => {
  const [open, setOpen] = useState(false)
  const dropdownRef = useRef()
  const menuItems: MenuItemType[] = actionDropdownItems.map(
    (actionDropdownItem, index) => {
      let label: JSX.Element = <></>
      if (actionDropdownItem.type === 'normal') {
        label = <>{actionDropdownItem.label}</>
      } else if (actionDropdownItem.type === 'confirm') {
        label = (
          <Popconfirm
            title={actionDropdownItem.popConfirmTitle}
            description={actionDropdownItem.popConfirmDescription}
            onConfirm={(event) => {
              event?.stopPropagation()
              if (actionDropdownItem.onClick) actionDropdownItem.onClick()
            }}
          >
            <a>{actionDropdownItem.label}</a>
          </Popconfirm>
        )
      } else if (actionDropdownItem.type === 'toggle') {
        label = (
          <ToggleDiv
            disabled={actionDropdownItem.disabled}
            onClick={() => actionDropdownItem.onClick()}
          >
            <span>{actionDropdownItem.label}</span>
            <Switch
              style={{ background: actionDropdownItem.disabled ? 'grey' : '' }}
              disabled={actionDropdownItem.disabled}
              size='small'
              checked={actionDropdownItem.switchState}
            />
          </ToggleDiv>
        )
      }
      return {
        key: index,
        onClick: (event) => {
          event.domEvent.stopPropagation()
          if (actionDropdownItem.type === 'normal') {
            actionDropdownItem.onClick()
            setOpen((prev) => !prev)
          }
        },
        label: label,
        disabled: actionDropdownItem.disabled,
        icon: actionDropdownItem.icon,
      }
    }
  )
  return (
    <Dropdown
      trigger={['click']}
      dropdownRender={() => <Menu items={menuItems} />}
      placement='bottomLeft'
    >
      <a
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          setOpen((prev) => !prev)
        }}
      >
        <MoreOutlined size={5} />
      </a>
    </Dropdown>
  )
}

export default ActionDropdown
